<template>
  <div></div>
</template>

<script>
const INVITATION_EXPIRED = 'invitation not found or already used';

export default {
  beforeRouteEnter(to, from, next) {
    const params = new URLSearchParams(window.location.search);
    const errorStatus = params.get('error');
    const errorDescription = params.get('error_description');
    if (errorStatus) {
      if (errorDescription === INVITATION_EXPIRED) {
        next({ name: 'Error', params: { statusCode: 410.1 } });
      } else {
        next({ name: 'Error' });
      }
    }
  },

  /*setup() {
    const { isAuthenticated, error } = useAuth0();
    const errorMessage = ref(null);
    const router = useRouter();

    onMounted(() => {
      // Check if there is an authentication error
      // go to error page
      if (error.value) {
        // errorMessage.value = error.value.message;
        router.push(Routes.Error);
      } else if (isAuthenticated.value) {
        // Redirect to the intended page or default page
        router.push(Routes.Home);
      }
    });

    return { errorMessage };
  },*/
};
</script>

<style>
.callback-container {
  /* Your styles for the container */
}
</style>
